var map = {
	"./clue_logo.svg": "2bST",
	"./cuona_logo.svg": "OnLs",
	"./cuona_nolabel_logo.svg": "4ZUs",
	"./cuona_small_logo.svg": "/QMe",
	"./cuona_text_logo.svg": "v1uf",
	"./favor_logo.svg": "BrmJ",
	"./favor_small_logo.svg": "C2sx",
	"./record_logo.svg": "nhfM",
	"./remotelock_logo.svg": "UXqf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+4E5";